var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_7:_Lovers_Haters",
    "data-name": "Stage 7: Lovers & Haters",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.042,
    height: 48.725,
    viewBox: "0 0 50.042 48.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 35.3,
    height: 33.306,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_686",
    "data-name": "Ellipse 686",
    cx: 25.021,
    cy: 24.363,
    rx: 25.021,
    ry: 24.363,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32063",
    "data-name": "Group 32063",
    transform: "translate(7.267 7.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32062",
    "data-name": "Group 32062",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13530",
    "data-name": "Path 13530",
    d: "M13.55,12.345Z",
    transform: "translate(10.325 9.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13531",
    "data-name": "Path 13531",
    d: "M8.812,14.62a5.5,5.5,0,0,0,5.471-5.083H3.315a5.534,5.534,0,0,0,5.5,5.083",
    transform: "translate(2.526 7.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13532",
    "data-name": "Path 13532",
    d: "M11.4,17.428h9.265a5.5,5.5,0,0,0-5.471-5.083c-.1,0-.192.026-.292.026a11.171,11.171,0,0,1-3.5,5.057",
    transform: "translate(8.685 9.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13533",
    "data-name": "Path 13533",
    d: "M17.561,2.92h-.046V15.945a11.344,11.344,0,0,1-.2,2.114c.107-.005.217-.019.328-.019a7.187,7.187,0,0,1,7.177,7.177A1.287,1.287,0,0,1,23.532,26.5H11.753a1.272,1.272,0,0,1-.87-.352,11.051,11.051,0,0,1-2.155.7,11.164,11.164,0,0,0,19.911-6.937l.011-13.025A17.321,17.321,0,0,0,17.561,2.92m4.673,12.218a3.405,3.405,0,0,1-3.4-3.4.846.846,0,0,1,1.69,0,1.711,1.711,0,1,0,3.422,0,.846.846,0,0,1,1.69,0,3.405,3.405,0,0,1-3.4,3.4",
    transform: "translate(6.651 2.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13534",
    "data-name": "Path 13534",
    d: "M22.346,17V3.972A17.326,17.326,0,0,0,11.256,0,18.065,18.065,0,0,0,0,3.972V17H0a11.173,11.173,0,0,0,22.346,0M15.937,7.977a3.4,3.4,0,0,1,3.4,3.4.844.844,0,1,1-1.688,0,1.713,1.713,0,0,0-3.425,0,.844.844,0,0,1-.842.844h0a.846.846,0,0,1-.846-.844,3.4,3.4,0,0,1,3.4-3.4m-12.392,3.4a3.4,3.4,0,0,1,6.8,0,.846.846,0,0,1-1.69,0,1.711,1.711,0,0,0-3.422,0,.846.846,0,0,1-1.69,0m7.8,12.2A7.174,7.174,0,0,1,4.167,16.4a1.288,1.288,0,0,1,1.285-1.285H17.234A1.285,1.285,0,0,1,18.513,16.4a7.174,7.174,0,0,1-7.173,7.173",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage7);
export default __webpack_public_path__ + "static/media/stage7.8c4cf2228ced391d74996049aa3bf266.svg";
export { ForwardRef as ReactComponent };